module.exports = new __parcel__URL__("alerts-task-two-illustration.11b778d2.png").toString();